import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { startWith, takeUntil } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators/map';
import { Observable, Subject, Subscription } from 'rxjs';
import { SharedService } from 'src/app/shared/service/shared.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/service/data.service';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-select-caivano-line',
  templateUrl: './select-caivano-line.component.html',
  styleUrls: ['./select-caivano-line.component.scss']
})

export class SelectCaivanoLineComponent implements OnInit, OnDestroy {
  filteredOptions: Observable<string[]>;
  factfilteredOptions: Observable<string[]>;
  linefilteredOptions: Observable<string[]>;
  timefilteredOptions = ["00:00 to 00:30", "00:30 to 01:00", "01:00 to 01:30", "01:30 to 02:00", "02:00 to 02:30", "02:30 to 03:00", "03:00 to 03:30", "03:30 to 04:00", "04:00 to 04:30", "04:30 to 05:00", "05:00 to 05:30", "05:30 to 06:00", "06:00 to 06:30", "06:30 to 07:00", "07:00 to 07:30", "07:30 to 08:00", "08:00 to 08:30", "08:30 to 09:00", "09:00 to 09:30", "09:30 to 10:00", "10:00 to 10:30", "10:30 to 11:00", "11:00 to 11.30", "11:30 to 12:00", "12:00 to 12:30", "12:30 to 13:00", "13:00 to 13:30", "13:30 to 14:00", "14:00 to 14:30", "14:30 to 15:00", "15:00 to 15:30", "15:30 to 16:00", "16:00 to 16:30", "16:30 to 17:00", "17:00 to 17:30", "17:30 to 18:00", "18:00 to 18:30", "18:30 to 19:00", "19:00 to 19:30", "19:30 to 20:00", "20:00 to 20:30", "20:30 to 21:00", "21:00 to 21:30", "21:30 to 22:00", "22:00 to 22:30", "22:30 to 23:00", "23:00 to 23:30", "23:30 to 24:00"];
  lineUnderCluster;
  lineUnderFactory;
  lineUnderLine;
  reportGeneratorTitle;
  dialogRef: any;
  clusterList: any[] = [];
  factoryList: any[] = [];
  lineList: any[] = [];
  lineSelector: UntypedFormGroup;
  lineListToStore: any;
  getDFOSFactoryListSubscription: Subscription;
  uniqueLineCluster: any[];
  selectedClusterFactory: any;
  selectedClusterforLine: any;
  selectedLR: any;
  selectedTimeZone: any;
  orderNumberOptions: any;
  selectedOrder: any;
  orderDetails: object;
  dataforLR: any[];
  orderListSubscription: Subscription;
  currentStartDate;
  minDate: Date;
  maxDate: Date;
  finalTimeZoneData: any;
  selectedDate: any;
  enableTime: boolean;

  public _filter(value: string): string[] {
    const filterValues = value.toLowerCase();
    return this.clusterList.filter(option => option && option.name && option.name.toLowerCase().includes(filterValues));
  }

  public _filterfact(value: string): string[] {
    const filterValues = value.toLowerCase();
    return this.factoryList.filter(option => option && option.name && option.name.toLowerCase().includes(filterValues));
  }

  public _filterline(value: string): string[] {
    const filterValues = value.toLowerCase();
    return this.lineList.filter(option => option && option.name && option.name.toLowerCase().includes(filterValues));
  }

  constructor(
    public formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private dialog: MatDialogRef<SelectCaivanoLineComponent>,
    private dataSer: DataService) {
    this.lineSelector = this.formBuilder.group({
      cluster: ['', [Validators.required]],
      clusterid: ['', [Validators.required]],
      factory: ['', [Validators.required]],
      factoryid: ['', [Validators.required]],
      line: ['', [Validators.required]],
      lineid: ['', [Validators.required]],
      timeSelectionLR: [''],
      orderLR: [''],
      dateSelectionLR: ['']

    });

    this.lineSelector.controls.factory.disable();
    this.lineSelector.controls.line.disable();
    this.lineSelector.controls.orderLR.disable();
    this.getCluster();
  }

  ngOnInit() {
    this.selectedLR = this.dialog._containerInstance._config.data;
    this.currentStartDate = new Date();
    this.currentStartDate.setDate(this.currentStartDate.getDate());
    // this.currentStartDate = this.currentStartDate.toISOString().slice(0, 10);
    const currentDateMoment = parseInt(this.currentStartDate.toISOString().slice(8, 10));
    // const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear, currentMonth, currentDateMoment - 5);
    this.maxDate = new Date(currentYear, currentMonth, currentDateMoment);
  }

  onClusterChange(selectedCluster: any) {
    if (selectedCluster.id) {
      this.lineUnderCluster = selectedCluster;
      this.lineSelector.controls.clusterid.setValue(selectedCluster.id);
      this.lineSelector.controls.factory.enable();
      this.lineSelector.controls.line.disable();
      this.lineSelector.controls.orderLR.disable();
      this.lineSelector.controls.timeSelectionLR.disable();
      this.getFactoryList(selectedCluster);
      this.lineSelector.controls.factory.setValue('');
      this.lineSelector.controls.line.setValue('');
    }
  }

  onFactoryChange(selectedFactory: any) {
    if (selectedFactory.id) {
      this.lineUnderFactory = selectedFactory;
      this.lineSelector.controls.factoryid.setValue(selectedFactory.id);
      this.lineSelector.controls.line.enable();
      this.lineSelector.controls.orderLR.disable();
      this.lineSelector.controls.timeSelectionLR.disable();
      this.lineSelector.controls.line.setValue('');
      this.getLineList(this.lineUnderCluster, this.lineUnderFactory);
    }
  }

  onLineChange(selectedLine) {
    if (selectedLine.id) {
      this.lineUnderLine = selectedLine;
      this.lineSelector.controls.lineid.setValue(selectedLine.id);
      this.lineSelector.controls.orderLR.enable();
      this.lineSelector.controls.timeSelectionLR.disable();
      this.selectOrder();
    }
  }
  onTimeChange(selectedTime) {
    if (selectedTime) {
      this.selectedTimeZone = selectedTime;
      this.finalTimeZoneData = this.selectedDate + " " + this.selectedTimeZone;
      console.log('finalTimeZoneData', this.finalTimeZoneData);
    }
  }

  valueChanged(event) {

    this.enableTime = false;
    console.log('event', event);
    //   this.selectedDate = event.value.toISOString().slice(0, 10);
    this.selectedDate = event.value.toLocaleString("zh-CN").slice(0, 10);
    if (this.selectedDate) {
      this.enableTime = true;
      this.lineSelector.controls.timeSelectionLR.enable();
    }

  }

  onOrderChange(selectedOrder) {
    if (selectedOrder) {
      this.selectedOrder = selectedOrder;
    }
  }

  selectOrder() {
    this.orderDetails = { cluster: this.lineUnderCluster.subRegionName, factory: this.lineUnderFactory.name, line: this.lineUnderLine.name };
    if (this.selectedLR === 'LR-dashboard') {
      this.orderListSubscription = this.sharedService.getOrderList(this.orderDetails)
        .subscribe(resp => {
          if (resp && resp.length) {
            this.orderNumberOptions = resp;
          }
        });
    }
  }

  getCluster() {
    this.clusterList = [];
    // const clusters = JSON.parse(localStorage.getItem('dfos.userfactory.data'));
    // console.log(JSON.stringify(clusters.filter(dat => dat.clusterId === 'Europe')));

    this.doAsyncTask().then((data: any[]) => {

      if (data) {
        this.clusterList = data;
      }
      this.filteredOptions = this.lineSelector.controls.cluster.valueChanges.pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.uniqueLineCluster = [];
      this.uniqueLineCluster = [...new Map(this.clusterList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));

      if (JSON.parse(this.dataSer.getStorageData('caivanoDashboard')) &&
        JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster) {
        if (this.clusterList && this.clusterList.length > 0) {
          const data = JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster.subRegionName;
          this.clusterList.forEach((cluster) => {
            if (cluster.name === JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster.name) {
              if (cluster.subRegionName === data) {
                this.lineSelector.controls.cluster.setValue(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster.subRegionName);
              } else {
                this.lineSelector.controls.cluster.setValue(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster.subRegionName);
              }
              this.onClusterChange(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).cluster);
            }
          });
        }
      }

    },
      (err) => {

      });
  }

  doAsyncTask() {
    return new Promise((resolve, reject) => {
      this.sharedService.getRealTimeClusterList().subscribe((data => {
        if (data && data.length > 0) {
          resolve(data);
          this.dataforLR = data;
        } else {
          reject('error');
        }
      }));
    });
  }

  processFactoryResponse(dataList, id) {
    const factoryResponse = {
      status: 'success',
      data: []
    };
    if (dataList.length > 0) {
      for (const clusterData of dataList) {
        if (clusterData.id === id) {
          if (clusterData.factoryList) {
            for (const factoryData of clusterData.factoryList) {
              const tempFactoryData = {
                name: factoryData.name,
                id: factoryData.id ? factoryData.id.$oid : '',
                language: factoryData.language,
                comments: factoryData.comments,
                isActive: factoryData.IsActive,
                localName: factoryData.localName,
                nodetype: factoryData.nodetype,
                sapPlantCode: factoryData.sapPlantCode,
                site: factoryData.site,
                timeZone: factoryData.timeZone,
                factoryId: factoryData.factoryId,
                latitude: (factoryData.latitude) ? factoryData.latitude : '',
                longitude: (factoryData.longitude) ? factoryData.longitude : ''
              };
              factoryResponse.data.push(tempFactoryData);
            }
          }
        }
      }
      return factoryResponse.data;
    } else {
      return factoryResponse.data;
    }
  }
  autoCompleteCluster(event: string) {
    this.f.factory.setValue('');
    this.f.factory.disable();
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      // const clonedClusterList = [...this.clusterList];
      this.uniqueLineCluster = [...new Map(this.clusterList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster = this.uniqueLineCluster.filter(c => {
        if (c.subRegionName.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
    } else {
      this.uniqueLineCluster = [...new Map(this.clusterList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
      // this.factoryList = this.factoryList;
    }
  }
  get f() {
    return this.lineSelector.controls;
  }
  autoCompleteFactory(event: string) {
    if (event && event !== '') {
      const searchKeyword = event.toLowerCase();
      const clonedFactoryList = [... this.factoryList];
      this.selectedClusterFactory = clonedFactoryList.filter(f => {
        if (f.name.toLowerCase().includes(searchKeyword)) {
          return true;
        }
      });
      this.selectedClusterFactory.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
    } else {
      this.uniqueLineCluster = [...new Map(this.clusterList.map((m) => [m.subRegionName, m])).values()];
      this.uniqueLineCluster.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
      this.selectedClusterFactory = this.factoryList;
      this.selectedClusterFactory.sort((a, b) => a.subRegionName.localeCompare(b.subRegionName));
    }
  }

  getFactoryList(selectedClusterData: any) {
    this.factoryList = [];
    this.selectedClusterFactory = [];
    if (this.clusterList && this.clusterList.length > 0) {
      // this.factoryList = this.processFactoryResponse(this.clusterList, selectedClusterData.id ?
      //  selectedClusterData.id : selectedClusterData.cluster.id);
      /*  this.factfilteredOptions = this.lineSelector.controls.factory.valueChanges
         .pipe(
           startWith(''),
           map(valueData => this._filterfact(valueData))
         ); */

      for (let index = 0; index < this.clusterList.length; index++) {
        if (this.clusterList[index].subRegionName === selectedClusterData.subRegionName) {
          this.clusterList.forEach((entry) => {
            entry.factoryList.forEach(element => {
              element['subRegionName'] = entry.subRegionName;
              element['selectedCLusterId'] = entry.clusterId;
            });
            // console.log("line Summary", entry);
          });
          this.selectedClusterFactory = this.factoryList = [...this.selectedClusterFactory, ...this.clusterList[index].factoryList];
          // this.fileredClusterList.concat(testList);
        }

      }
      this.selectedClusterFactory.sort((a, b) => a.name.localeCompare(b.name));

      if (JSON.parse(this.dataSer.getStorageData('caivanoDashboard')) &&
        JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory) {
        if (this.factoryList && this.factoryList.length > 0) {
          this.factoryList.forEach((factoryData) => {
            if (factoryData.name === JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory.name) {
              this.lineSelector.controls.factory.setValue(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory.name);
              this.onFactoryChange(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory);
            }
          });
        }
      }
    } else {
      this.getDFOSFactoryListSubscription = this.sharedService.getDFOSFactoryList(selectedClusterData)
        .subscribe(result => {
          this.factoryList = result;
          this.factfilteredOptions = this.lineSelector.controls.factory.valueChanges
            .pipe(
              startWith(''),
              map(valueOrder => this._filterfact(valueOrder))
            );

          if (JSON.parse(this.dataSer.getStorageData('caivanoDashboard')) &&
            JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory) {
            if (this.factoryList && this.factoryList.length > 0) {
              this.factoryList.forEach((factoryDt) => {
                if (factoryDt.name === JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory.name) {
                  this.lineSelector.controls.factory.setValue(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory.name);
                  this.onFactoryChange(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).factory);
                }
              });
            }
          }
        });
    }
  }

  getLineList(selectedCluster: any, selectedFactory: any) {
    this.lineList = [];
    this.lineListToStore = [];
    // this.sharedService.getDFOSLineList({ cluster: selectedCluster, factory: selectedFactory }).subscribe(result => {
    // this.sharedService.getRealTimeLineList({ cluster: selectedCluster, factory: selectedFactory })
    //   // .pipe(takeUntil(this.destroy$))
    //   .subscribe(result => {
    // test code for mapping to correct cluster
    //  if (!selectedFactory.factoryId.includes(selectedCluster.factoryList)) {
    this.selectedClusterforLine = this.clusterList.find(x => x.clusterId === selectedFactory.selectedCLusterId && x.subRegionName === selectedFactory.subRegionName);
    console.log('selectedClusterforLine', this.selectedClusterforLine);
    this.lineUnderCluster = this.selectedClusterforLine;
    if (this.selectedClusterforLine && this.selectedClusterforLine.factoryList && this.selectedClusterforLine.factoryList.length > 0) {
      this.lineList = this.selectedClusterforLine.factoryList.find(fact => fact.factoryId === selectedFactory.factoryId).lineList;
    } else {
      this.lineUnderCluster = selectedCluster;
      if (selectedCluster && selectedCluster.factoryList && selectedCluster.factoryList.length > 0) {
        this.lineList = selectedCluster.factoryList.find(fact => fact.factoryId === selectedFactory.factoryId).lineList;
      }
    }
    const lineListData = [];
    this.lineList.forEach((item) => {
      const obj = {
        name: item.name,
        Name: item.name,
        id: item.lineId,
        Id: item.lineId,
        lineId: item.name
      };
      lineListData.push(obj);
    });
    this.lineList = lineListData;

    this.lineListToStore = this.lineList;

    this.linefilteredOptions = this.lineSelector.controls.line.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterline(value))
      );

    if (JSON.parse(this.dataSer.getStorageData('caivanoDashboard')) &&
      JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).line) {
      if (this.lineList && this.lineList.length > 0) {
        this.lineList.forEach((line) => {
          if (line.name === JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).line.name) {
            this.lineSelector.controls.line.setValue(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).line.name);
            this.onLineChange(JSON.parse(this.dataSer.getStorageData('caivanoDashboard')).line);

          }
        });
      }
    }

    //  }
    // });
  }

  valueReset(catg: any) {
    if (catg === 'cluster') {
      this.lineSelector.controls.clusterid.reset();
      this.lineSelector.controls.factory.disable();
      this.lineSelector.controls.line.disable();
      this.lineSelector.controls.orderLR.disable();
      this.lineSelector.controls.timeSelectionLR.reset();
      this.lineSelector.controls.dateSelectionLR.reset();
      this.lineSelector.controls.timeSelectionLR.disable();
    } else if (catg === 'factory') {
      this.lineSelector.controls.factoryid.reset();
      this.lineSelector.controls.line.disable();
      this.lineSelector.controls.orderLR.disable();
      this.lineSelector.controls.timeSelectionLR.reset();
      this.lineSelector.controls.dateSelectionLR.reset();
      this.lineSelector.controls.timeSelectionLR.disable();
    } else if (catg === 'line') {
      this.lineSelector.controls.lineid.reset();
      this.lineSelector.controls.orderLR.disable();
      this.lineSelector.controls.timeSelectionLR.reset();
      this.lineSelector.controls.dateSelectionLR.reset();
      this.lineSelector.controls.timeSelectionLR.disable();
    }
  }

  dialogClose() {
    this.dialog.close('cancelled');
  }

  onSubmit() {
    this.dialog.close({
      action: 'submitted',
      selectedValues: {
        cluster: this.lineUnderCluster,
        factory: this.lineUnderFactory,
        line: this.lineUnderLine,
        lineList: this.lineListToStore,
        timeZoneData: this.finalTimeZoneData,
        orderDetails: this.selectedOrder,
        currentDate: this.currentStartDate
      }
    });
  }

  ngOnDestroy(): void {
    if (this.getDFOSFactoryListSubscription) {
      this.getDFOSFactoryListSubscription.unsubscribe();
    }
    if (this.orderListSubscription) {
      this.orderListSubscription.unsubscribe();
    }
  }
}
